import io from 'socket.io-client';
import Feathers from '@feathersjs/feathers';
import auth from '@feathersjs/authentication-client';
import socketio from '@feathersjs/socketio-client';
import Vue from 'vue';
import uuid from 'uuid';

const overlord = new Feathers();
Vue.prototype.overlord = overlord;

const clientId = uuid.v4();
const socketUrl = window.location.origin;
overlord.connectionId = clientId;

const socket = io(`${socketUrl}?clientId=${clientId}`, {
  reconnectionDelay: 10,
  reconnectionDelayMax: 1000,
  rememberUpgrade: true,
  transports: ['websocket'],
});
console.debug(`[Overlord] Current client session connectionId ${clientId}`);
overlord.configure(socketio(socket, {
  timeout: 20000,
}));
overlord.configure(auth());

/** @return {Promise<void>} */
export const overlordConnect = async () => {
  if (overlord.io.disconnected) {
    await overlord.io.open();
  }
};

export default overlord;
